const initWorkCardBars = (tablist: Element): void => {
  const bars = Array.from(tablist.querySelectorAll(".dex-fyio-top-bar")) as HTMLElement[];
  const visual = tablist.closest(".dex-project-card-large__visual");
  const slides = visual
    ? (Array.from(visual.querySelectorAll(".dex-work-visual-slide")) as HTMLElement[])
    : [];
  const n = Math.max(bars.length, slides.length, 1);
  const mqReduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  let timer: ReturnType<typeof setInterval> | null = null;
  let onFillEnd: (() => void) | null = null;

  const clearFillEnd = (): void => {
    if (onFillEnd) {
      bars.forEach((b) => {
        const f = b.querySelector(".dex-fyio-top-bar__fill");
        if (f) f.removeEventListener("animationend", onFillEnd!);
      });
      onFillEnd = null;
    }
  };

  const resetFills = (): void => {
    bars.forEach((b) => {
      const f = b.querySelector(".dex-fyio-top-bar__fill") as HTMLElement | null;
      if (!f) return;
      f.classList.remove("fyio-top-bar__fill--playing");
      if (mqReduce.matches) {
        f.style.removeProperty("transform");
        f.style.removeProperty("animation");
      } else {
        f.style.transform = "scaleX(0)";
        f.style.animation = "none";
        void f.offsetWidth;
        f.style.removeProperty("animation");
      }
    });
  };

  const goTo = (i: number): void => {
    const idx = ((i % n) + n) % n;
    bars.forEach((b, j) => {
      const on = j === idx;
      b.classList.toggle("dex-is-active", on);
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    slides.forEach((s, j) => {
      s.classList.toggle("dex-is-active", j === idx);
    });
  };

  const startProgress = (): void => {
    clearFillEnd();
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    resetFills();

    if (mqReduce.matches) {
      timer = setInterval(() => {
        const cur = bars.findIndex((b) => b.classList.contains("dex-is-active"));
        goTo(cur >= 0 ? (cur + 1) % n : 0);
      }, 5000);
      return;
    }

    const idx = bars.findIndex((b) => b.classList.contains("dex-is-active"));
    const fill = bars[idx]
      ? (bars[idx].querySelector(".dex-fyio-top-bar__fill") as HTMLElement | null)
      : null;
    if (!fill) return;

    onFillEnd = () => {
      clearFillEnd();
      const cur = bars.findIndex((b) => b.classList.contains("dex-is-active"));
      goTo(cur >= 0 ? (cur + 1) % n : 0);
      startProgress();
    };

    fill.addEventListener("animationend", onFillEnd);

    requestAnimationFrame(() => {
      fill.style.removeProperty("transform");
      fill.classList.add("fyio-top-bar__fill--playing");
    });
  };

  bars.forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = Number((btn as HTMLElement).dataset.workBar);
      if (Number.isNaN(id)) return;
      goTo(id);
      startProgress();
    });
  });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      clearFillEnd();
      resetFills();
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    } else {
      startProgress();
    }
  });

  startProgress();
};

document.querySelectorAll(".dex-fyio-top-bars").forEach(initWorkCardBars);

const initTagPillRotation = (): void => {
  const rows = Array.from(document.querySelectorAll(".dex-tag-row"));
  if (!rows.length) return;

  const rowStates = rows
    .map((row) => {
      const pills = Array.from(row.querySelectorAll(".dex-tag-pill")) as HTMLElement[];
      if (!pills.length) return null;
      const activeIdx = pills.findIndex((pill) =>
        pill.classList.contains("dex-tag-pill--dark")
      );
      const idx = activeIdx >= 0 ? activeIdx : 0;
      pills.forEach((pill, i) => pill.classList.toggle("dex-tag-pill--dark", i === idx));
      return { pills, idx };
    })
    .filter((state): state is { pills: HTMLElement[]; idx: number } => state !== null);

  if (!rowStates.length) return;

  window.setInterval(() => {
    rowStates.forEach((state) => {
      state.idx = (state.idx + 1) % state.pills.length;
      state.pills.forEach((pill, i) =>
        pill.classList.toggle("dex-tag-pill--dark", i === state.idx)
      );
    });
  }, 4000);
};

initTagPillRotation();

/** “As featured in”: pixel-accurate loop (–50% vs segment width often caused a gap before reset). */
const initFeaturedMarquee = (): void => {
  const mqReduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  document.querySelectorAll<HTMLElement>(".dex-featured-in__marquee").forEach((marquee) => {
    const firstSeg = marquee.querySelector(".dex-featured-in__seg") as HTMLElement | null;
    if (!firstSeg) return;

    const applyShift = (): void => {
      if (mqReduce.matches) {
        marquee.style.removeProperty("--featured-marquee-shift");
        return;
      }
      const w = firstSeg.getBoundingClientRect().width;
      if (w <= 0) return;
      marquee.style.setProperty("--featured-marquee-shift", `${-w}px`);
    };

    applyShift();

    const imgs = marquee.querySelectorAll("img");
    imgs.forEach((img) => {
      if (!(img as HTMLImageElement).complete) {
        img.addEventListener("load", applyShift, { once: true });
      }
    });

    let ro: ResizeObserver | null = null;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(() => applyShift());
      ro.observe(firstSeg);
    } else {
      window.addEventListener("resize", applyShift);
    }

    mqReduce.addEventListener("change", applyShift);
  });
};

initFeaturedMarquee();
